// eslint-disable-next-line import/prefer-default-export
export const LAST_DEPLOY_DATE = process.env.REACT_APP_LAST_DEPLOY_DATE
